/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CountryCode} from "./countryCode.zod";
import {ExpedientState} from "./expedientState.zod";
import {HeliportEnvironment} from "./heliportEnvironment.zod";

export const listExpedientsParamsSortKeyDefault = `name`;
export const ListExpedientsParams = zod.object({
  sortKey: zod.enum(["name", "number"]).default(listExpedientsParamsSortKeyDefault),
  q: zod.string().optional(),
  state: ExpedientState.optional(),
  countryCodes: zod.array(CountryCode).optional(),
  location: HeliportEnvironment.optional(),
  customerId: zod.uuid().optional(),
  responsibleUserId: zod.uuid().optional(),
});

export type ListExpedientsParams = zod.input<typeof ListExpedientsParams>;
export type ListExpedientsParamsOutput = zod.output<typeof ListExpedientsParams>;
